<template>
  <button
    class="flex items-center w-full p-3 hover:bg-gray-5"
    :class="{
      'bg-block-2 p-3': isSelected,
    }"
    @click="selectCollateral"
  >
    <div
      class="flex flex-row items-center justify-start gap-3 text-white relative w-full"
    >
      <img
        :src="collateral.token.img"
        alt=""
        class="h-8 w-8 rounded-full"
      />
      <div class="flex flex-col items-start">
        <!-- <a
          href="#"
          target="_blank"
          rel="noopener noreferrer"
          class="text-base text-white font-semibold hover:underline"
        >
          {{ collateral.token.symbol }}
        </a> -->
        {{ collateral.token.symbol }}
        <span class="text-gray-3 text-sm font-semibold">
          {{ collateral.token.name }}
        </span>
      </div>
    </div>
    <div class="text-white text-sm font-medium text-right self-end">
      {{ userCollateralBalanceFormatted }}
      {{ collateral.token.symbol }}
      <span class="text-success">
        (${{ userCollateralBalanceUSDFormatted }})
      </span>
    </div>
  </button>
</template>

<script>
import { mapState } from "vuex";
import BigNumber from "bignumber.js";
import { formatDynamicDecimals } from "../../factories/Utils";

export default {
  name: "HypeSelectButton",

  props: {
    collateral: { type: Object, required: true },
    isSelected: { type: Boolean, default: false },
  },

  emits: ["select"],

  computed: {
    ...mapState({
      userCollateralBalance({ main }) {
        const balObj =
          main[
            `tokenUserBal_${this.collateral.token.address.toLowerCase()}`
          ];
        return (balObj && balObj.balanceOf) || 0;
      },
    }),

    userCollateralBalanceFixed() {
      return (
        (this.collateral &&
          this.collateral.token &&
          this.collateral.token.decimals &&
          new BigNumber(this.userCollateralBalance)
            .div(
              new BigNumber(10).pow(this.collateral.token.decimals)
            )
            .toFixed()) ||
        "0"
      );
    },

    userCollateralBalanceFormatted() {
      return formatDynamicDecimals(this.userCollateralBalanceFixed);
    },

    userCollateralBalanceUSDFormatted() {
      return (
        new BigNumber(this.userCollateralBalanceFixed)
          .times(this.collateral.priceUSD)
          .toFormat(2) || "0"
      );
    },
  },

  methods: {
    selectCollateral() {
      this.$emit("select", this.collateral);
    },
  },
};
</script>
